import { Box, Tooltip, Typography } from "src/components/MuiGenerals";
import { Params } from "src/features/common/types/GridRenderCellParams";
import { useTranslation } from "src/hooks";
import { GetListRes } from "../types/GetListRes";
import { TableColumnKey } from "../types/Table";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";

const useWalletCountCell = () => {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);

  const renderWalletCountCell = (params: Params<GetListRes>) => {
    const walletCount = params?.row?.[TableColumnKey.WalletsCount];
    const thresholdWalletCount =
      params?.row?.rawData.approve_allowance_asset_config
        .notification_threshold_count;

    if (params?.row?.isWalletCountLargerThanThreshold) {
      return (
        <Tooltip
          title={`${t("address_count_tooltip", {
            number: thresholdWalletCount,
          })}`}>
          <Box display={"flex"} alignItems={"center"} gap={"0.5rem"}>
            <Typography color={"red"} children={`${walletCount}`} />
          </Box>
        </Tooltip>
      );
    }
    return (
      <Tooltip title={walletCount}>
        <Typography children={walletCount} />
      </Tooltip>
    );
  };

  return { renderWalletCountCell };
};
export default useWalletCountCell;
